import React from "react";

import { cn } from "@/app/handlers/cn.utils";

interface StatsCardProps {
	title: string;
	value: number | string;
	subtitle?: string;
	subtitleColor?: string;
	icon: React.ReactNode;
}

export const StatsCard = ({ title, value, subtitle, subtitleColor = "text-green-600", icon }: StatsCardProps) => (
	<div className="bg-white rounded-lg border border-gray-200 p-5 flex items-start justify-between">
		<div>
			<p className="text-sm text-gray-500 mb-1">{title}</p>
			<p className="text-3xl font-bold text-gray-900">{value}</p>
			{subtitle && <p className={cn("text-xs mt-1", subtitleColor)}>{subtitle}</p>}
		</div>
		<div className="text-gray-400">{icon}</div>
	</div>
);

export default StatsCard;
